//
import SlCustomerModel from '@/models/Sale/SlCustomer'

/**
 * This class describes a sl customer.
 * @class SlCustomer (name)
 */
export default class SlCustomer extends SlCustomerModel {

	/**
	 * { function_description }
	 * @return {SlCustomerModel}  The sl customer model.
	 */
	static blockUnlock() {
		return new SlCustomerModel({ id: 'block_unblock' })
	}

	/**
	 * { function_description }
	 * @return {SlCustomerModel}  The sl customer model.
	 */
	static changeMaxCustomerCredit() {
		return new SlCustomerModel({ id: 'change_max_customer_credit' })
	}
}